
export const resetEditWorkerReducer = (state:any) => {
    state.editWorker.status = "idle";
    state.editWorker.errorMessage = "";
  }